import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CalendarTwoToneSvg from "@ant-design/icons-svg/es/asn/CalendarTwoTone";
import AntdIcon from "../components/AntdIcon";
var CalendarTwoTone = function CalendarTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CalendarTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CalendarTwoTone.displayName = 'CalendarTwoTone';
}
export default /*#__PURE__*/React.forwardRef(CalendarTwoTone);